import { ChangeDetectionStrategy, Component, computed, inject, input, model, ViewEncapsulation } from '@angular/core';
import { PlatformService, WINDOW } from '@seven1/angular/ssr';

@Component({
    selector: 's1-pagination',
    imports: [],
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 's1-pagination',
    },
})
export class PaginationComponent {
    private _window = inject(WINDOW);
    private _platform = inject(PlatformService);

    page = model.required<number>();
    total = input.required<number>();
    per_page = input.required<number>();
    totalPages = computed<number>(() => {
        return Math.ceil((this.total() || 1) / (this.per_page() || 5));
    });
    
    scrollToTarget(): void {
        if (this._platform.isBrowser) {
            if (this._window) {
                this._window.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    }
}
